import React, { useRef, useState } from "react";
import {
  GoogleMap,
  Marker,
  InfoWindow,
  useJsApiLoader,
} from "@react-google-maps/api";

import greenLocator from "../assets/images/green-locator.png"
import yellowLocator from "../assets/images/yellow-locator.png"
import redLocator from "../assets/images/red-locator.png"

import { Button, Box, Typography } from "@mui/material";

const containerStyle = {
   width: "100%",
  height: "360px",
};


const UKMapWithMarkers = ({locations, newStore, oldStore, setNewStore, setNewSlots, SelectedSubService, getTimeSlots, setNewSelectedTime}) => {
  console.log("oldStore Data", oldStore)
  const center = { lat: newStore?.Latitude, lng: newStore?.Longitude };
  const [infoWindow, setInfoWindow] = useState(null);
  const mapRef = useRef(null);
  let key = process.env.REACT_APP_GMAPS_KEY;
  console.log("API KEY MAP", key)

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: key,
    id: "google-map-script",
  });

  const handleSelect = (loc) => {
    setNewStore(loc);
    getTimeSlots(setNewSlots, loc.Id);
    setNewSelectedTime(null)
    setInfoWindow(null);
    if (mapRef.current) {
      mapRef.current.panTo({ lat: loc.Latitude, lng: loc.Longitude });
    }
  };

  if (!isLoaded) return <div>Loading Map...</div>;

  const LegendItem = ({ color, label }) => (
  <Box display="flex" alignItems="center" mb={1} mr={2}>
    <Box
      sx={{
        width: 16,
        height: 16,
        backgroundColor: color,
        marginRight: 0.5,
        // border: '1px solid #ccc',
        borderRadius: "5px"
      }}
    />
    <Typography variant="body2">{label}</Typography>
  </Box>
);

  return (
    <Box sx={{mx:1}}>
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={center}
        zoom={7}
        onLoad={(map) => {
          mapRef.current = map;
          // const bounds = new window.google.maps.LatLngBounds();
          // locations.forEach((loc) => bounds.extend({ lat: loc.Latitude || 0, lng: loc.Longitude || 0 }));
          // map.fitBounds(bounds);
        }}
      >
        {locations.map((loc) => (
          <Marker
            key={loc.Id}
            position={{ lat: loc.Latitude || 0, lng: loc.Longitude || 0 }}
            icon={{
                url: loc.Id == oldStore?.Id ? redLocator : loc.Id === newStore?.Id ? yellowLocator : greenLocator,
                scaledSize: new window.google.maps.Size(
                  loc.Id === newStore?.Id ? 45 : 30,
                  loc.Id === newStore?.Id ? 45 : 30
                ),
              }}
            onClick={() => setInfoWindow(loc)}
          />
        ))}

        {infoWindow && (
          <InfoWindow
            position={{ lat: infoWindow.Latitude || 0, lng: infoWindow.Longitude || 0 }}
            onCloseClick={() => setInfoWindow(null)}
          >
            <Box sx={{ p: 0, maxWidth: 200, p:-2 }}>
              <Typography fontWeight={"bold"} variant="h5">{infoWindow.StoreName}</Typography>
              <Typography variant="body2">{infoWindow.Location}</Typography>
              <Typography variant="body2">{infoWindow.Phone}</Typography>
              <Box mt={2} display="flex" justifyContent="center">
                {infoWindow.Id != newStore.Id && <Button
                  variant="contained"
                  size="small"
                  fontWeight={"bold"}
                  onClick={() => handleSelect(infoWindow)}
                >
                  Select Store
                </Button>}
              </Box>
            </Box>
          </InfoWindow>
        )}
      </GoogleMap>
      <Box
  sx={{
    display: 'flex',
    flexDirection: {
      xs: 'column', 
      sm: 'row',   
    },
    my: 1,
    // gap: 2,
  }}
>
  <LegendItem color="#DC143C" label="Previously Selected Store" />
  <LegendItem color="#EE8016" label="Alternative Store Selected" />
  <LegendItem color="#2DAC70" label="Suggested Stores" />
</Box>
    </Box>
  );
};

export default UKMapWithMarkers;

